const utils = require('frontend-controller/lib/utils');
module.exports = {
	extends: [
		'/',
		'templates',
		'propertiesForms',
		'componentContentForm'
	],

	config: {
		resourceConnected: false, // resourceConnected flag will be handled via onBeforeRender
	},

	methods: {
		onBeforeSanitizeForm(){
			this.closest('templates_ninja_gatekeeper_componentInstance', gatekeeper => {
				if(
					(gatekeeper.model.ninjaModuleSubConfig || {}).showComponentContentProperties === false ||
					(gatekeeper.model.ninjaConfig || {}).showComponentContentProperties === false
				){
					utils.forEach(this.model.fields || [], (field, fieldIndex) => {
						// let fields with leading underscores be used.
						// e.g., _internalMediaTags is needed for all media fields to provide tag assignment capabilities.
						if(String(field.fieldCode || '').match(/^\s*_/) === null){
							field.atom = field.atom || {}
							field.atom.renderType = 'none'
						}
					})

					this.formMapping = {
						cols: [
							[
								{
									type: 'fieldGroup',
									source: 'resourceFields'
								}
							]
						]
					}
				}
				return 'break'
			})
		},

		onBeforeRender(){
			// since the gatekeeper will not render this form until the record has been created, it would not prepare properly in cases without autoCreate feature.
			this.config.resourceConnected = !!this.config.resourceUrl
		},
	}
};
